// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file auth/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum com.neulink.pharmacy.Level
 */
export enum Level {
  /**
   * @generated from enum value: LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LEVEL_COMPANY = 1;
   */
  COMPANY = 1,

  /**
   * @generated from enum value: LEVEL_BRANCH = 2;
   */
  BRANCH = 2,

  /**
   * @generated from enum value: LEVEL_STOCK_POINT = 3;
   */
  STOCK_POINT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(Level)
proto3.util.setEnumType(Level, "com.neulink.pharmacy.Level", [
  { no: 0, name: "LEVEL_UNSPECIFIED" },
  { no: 1, name: "LEVEL_COMPANY" },
  { no: 2, name: "LEVEL_BRANCH" },
  { no: 3, name: "LEVEL_STOCK_POINT" },
]);

/**
 * @generated from enum com.neulink.pharmacy.Role
 */
export enum Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Can view data
   *
   * @generated from enum value: ROLE_VIEW = 1;
   */
  VIEW = 1,

  /**
   * Can write data
   *
   * @generated from enum value: ROLE_WRITE = 2;
   */
  WRITE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(Role)
proto3.util.setEnumType(Role, "com.neulink.pharmacy.Role", [
  { no: 0, name: "ROLE_UNSPECIFIED" },
  { no: 1, name: "ROLE_VIEW" },
  { no: 2, name: "ROLE_WRITE" },
]);

/**
 * @generated from enum com.neulink.pharmacy.PharmacySize
 */
export enum PharmacySize {
  /**
   * @generated from enum value: SIZE_UNSPECIFIED = 0;
   */
  SIZE_UNSPECIFIED = 0,

  /**
   * Small pharmacy
   *
   * @generated from enum value: SIZE_SMALL = 1;
   */
  SIZE_SMALL = 1,

  /**
   * Medium pharmacy
   *
   * @generated from enum value: SIZE_MEDIUM = 2;
   */
  SIZE_MEDIUM = 2,

  /**
   * Large pharmacy
   *
   * @generated from enum value: SIZE_LARGE = 3;
   */
  SIZE_LARGE = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(PharmacySize)
proto3.util.setEnumType(PharmacySize, "com.neulink.pharmacy.PharmacySize", [
  { no: 0, name: "SIZE_UNSPECIFIED" },
  { no: 1, name: "SIZE_SMALL" },
  { no: 2, name: "SIZE_MEDIUM" },
  { no: 3, name: "SIZE_LARGE" },
]);

/**
 * @generated from enum com.neulink.pharmacy.PharmacyStatus
 */
export enum PharmacyStatus {
  /**
   * Unknown status
   *
   * @generated from enum value: STATUS_UNKNOWN = 0;
   */
  STATUS_UNKNOWN = 0,

  /**
   * Pharmacy is pending approval
   *
   * @generated from enum value: STATUS_PENDING_APPROVAL = 1;
   */
  STATUS_PENDING_APPROVAL = 1,

  /**
   * Pharmacy is active
   *
   * @generated from enum value: STATUS_ACTIVE = 2;
   */
  STATUS_ACTIVE = 2,

  /**
   * Pharmacy is blocked
   *
   * @generated from enum value: STATUS_BLOCKED = 3;
   */
  STATUS_BLOCKED = 3,

  /**
   * Pharmacy is awaiting payment
   *
   * @generated from enum value: STATUS_AWAITING_PAYMENT = 4;
   */
  STATUS_AWAITING_PAYMENT = 4,

  /**
   * Pharmacy is inactive
   *
   * @generated from enum value: STATUS_INACTIVE = 5;
   */
  STATUS_INACTIVE = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(PharmacyStatus)
proto3.util.setEnumType(PharmacyStatus, "com.neulink.pharmacy.PharmacyStatus", [
  { no: 0, name: "STATUS_UNKNOWN" },
  { no: 1, name: "STATUS_PENDING_APPROVAL" },
  { no: 2, name: "STATUS_ACTIVE" },
  { no: 3, name: "STATUS_BLOCKED" },
  { no: 4, name: "STATUS_AWAITING_PAYMENT" },
  { no: 5, name: "STATUS_INACTIVE" },
]);

/**
 * @generated from enum com.neulink.pharmacy.StockPointType
 */
export enum StockPointType {
  /**
   * Unknown stock point type
   *
   * @generated from enum value: STOCK_POINT_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Receiving stock point
   *
   * @generated from enum value: STOCK_POINT_TYPE_RECEIVING = 1;
   */
  RECEIVING = 1,

  /**
   * Selling stock point
   *
   * @generated from enum value: STOCK_POINT_TYPE_SELLING = 2;
   */
  SELLING = 2,

  /**
   * Consuming stock point
   *
   * @generated from enum value: STOCK_POINT_TYPE_CONSUMING = 3;
   */
  CONSUMING = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(StockPointType)
proto3.util.setEnumType(StockPointType, "com.neulink.pharmacy.StockPointType", [
  { no: 0, name: "STOCK_POINT_TYPE_UNKNOWN" },
  { no: 1, name: "STOCK_POINT_TYPE_RECEIVING" },
  { no: 2, name: "STOCK_POINT_TYPE_SELLING" },
  { no: 3, name: "STOCK_POINT_TYPE_CONSUMING" },
]);

/**
 * @generated from message com.neulink.pharmacy.PharmacyAccess
 */
export class PharmacyAccess extends Message<PharmacyAccess> {
  /**
   * @generated from field: com.neulink.pharmacy.Level level = 1;
   */
  level = Level.UNSPECIFIED;

  /**
   * Unique identifier for the pharmacy, branch, or stock point
   *
   * @generated from field: string id = 2;
   */
  id = "";

  /**
   * Name of the pharmacy, branch, or stock point
   *
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * List of roles associated with the access
   *
   * @generated from field: repeated com.neulink.pharmacy.Role roles = 4;
   */
  roles: Role[] = [];

  constructor(data?: PartialMessage<PharmacyAccess>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PharmacyAccess";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "level", kind: "enum", T: proto3.getEnumType(Level) },
    { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "roles", kind: "enum", T: proto3.getEnumType(Role), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PharmacyAccess {
    return new PharmacyAccess().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PharmacyAccess {
    return new PharmacyAccess().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PharmacyAccess {
    return new PharmacyAccess().fromJsonString(jsonString, options);
  }

  static equals(a: PharmacyAccess | PlainMessage<PharmacyAccess> | undefined, b: PharmacyAccess | PlainMessage<PharmacyAccess> | undefined): boolean {
    return proto3.util.equals(PharmacyAccess, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PharmacyMetadata
 */
export class PharmacyMetadata extends Message<PharmacyMetadata> {
  /**
   * Contact email for the pharmacy
   *
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * URL to the pharmacy's logo
   *
   * @generated from field: string logo_url = 2;
   */
  logoUrl = "";

  /**
   * Timezone of the pharmacy
   *
   * @generated from field: string timezone = 3;
   */
  timezone = "";

  /**
   * Country code of the pharmacy
   *
   * @generated from field: string country_code = 4;
   */
  countryCode = "";

  /**
   * Currency code used by the pharmacy
   *
   * @generated from field: string currency_code = 5;
   */
  currencyCode = "";

  /**
   * Name of the pharmacy
   *
   * @generated from field: string pharmacy_name = 6;
   */
  pharmacyName = "";

  /**
   * Primary contact phone number
   *
   * @generated from field: string primary_phone = 7;
   */
  primaryPhone = "";

  /**
   * WhatsApp contact phone number
   *
   * @generated from field: string whatsapp_phone = 8;
   */
  whatsappPhone = "";

  /**
   * Operating hours of the pharmacy
   *
   * @generated from field: map<string, string> operating_hours = 9;
   */
  operatingHours: { [key: string]: string } = {};

  /**
   * Secondary contact phone number
   *
   * @generated from field: string secondary_phone = 10;
   */
  secondaryPhone = "";

  /**
   * Tax identifiers associated with the pharmacy
   *
   * @generated from field: repeated com.neulink.pharmacy.TaxIdentifier tax_identifiers = 11;
   */
  taxIdentifiers: TaxIdentifier[] = [];

  /**
   * Default language for the pharmacy
   *
   * @generated from field: string default_language = 12;
   */
  defaultLanguage = "";

  /**
   * Unique identifier for the establishment
   *
   * @generated from field: string establishment_id = 13;
   */
  establishmentId = "";

  /**
   * Base UPI ID for the pharmacy
   *
   * @generated from field: string base_upi_id = 14;
   */
  baseUpiId = "";

  constructor(data?: PartialMessage<PharmacyMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PharmacyMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "logo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "pharmacy_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "primary_phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "whatsapp_phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "operating_hours", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 10, name: "secondary_phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "tax_identifiers", kind: "message", T: TaxIdentifier, repeated: true },
    { no: 12, name: "default_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "establishment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "base_upi_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PharmacyMetadata {
    return new PharmacyMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PharmacyMetadata {
    return new PharmacyMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PharmacyMetadata {
    return new PharmacyMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: PharmacyMetadata | PlainMessage<PharmacyMetadata> | undefined, b: PharmacyMetadata | PlainMessage<PharmacyMetadata> | undefined): boolean {
    return proto3.util.equals(PharmacyMetadata, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.TaxIdentifier
 */
export class TaxIdentifier extends Message<TaxIdentifier> {
  /**
   * Type of tax identifier (e.g., TRN)
   *
   * @generated from field: string type = 1;
   */
  type = "";

  /**
   * Value of the tax identifier
   *
   * @generated from field: string value = 2;
   */
  value = "";

  /**
   * Description of the tax identifier
   *
   * @generated from field: string description = 3;
   */
  description = "";

  constructor(data?: PartialMessage<TaxIdentifier>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TaxIdentifier";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaxIdentifier {
    return new TaxIdentifier().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaxIdentifier {
    return new TaxIdentifier().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaxIdentifier {
    return new TaxIdentifier().fromJsonString(jsonString, options);
  }

  static equals(a: TaxIdentifier | PlainMessage<TaxIdentifier> | undefined, b: TaxIdentifier | PlainMessage<TaxIdentifier> | undefined): boolean {
    return proto3.util.equals(TaxIdentifier, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PharmacyLocationDetails
 */
export class PharmacyLocationDetails extends Message<PharmacyLocationDetails> {
  /**
   * Address of the pharmacy
   *
   * @generated from field: string address = 1;
   */
  address = "";

  /**
   * Emirate where the pharmacy is located
   *
   * @generated from field: string emirate = 2;
   */
  emirate = "";

  /**
   * Latitude of the pharmacy's location
   *
   * @generated from field: double latitude = 3;
   */
  latitude = 0;

  /**
   * Longitude of the pharmacy's location
   *
   * @generated from field: double longitude = 4;
   */
  longitude = 0;

  /**
   * Country code of the pharmacy's location
   *
   * @generated from field: string country_code = 5;
   */
  countryCode = "";

  /**
   * Postal code of the pharmacy's location
   *
   * @generated from field: string postal_code = 6;
   */
  postalCode = "";

  /**
   * City where the pharmacy is located
   *
   * @generated from field: string city = 7;
   */
  city = "";

  /**
   * State where the pharmacy is located
   *
   * @generated from field: string state = 8;
   */
  state = "";

  constructor(data?: PartialMessage<PharmacyLocationDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PharmacyLocationDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "emirate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "latitude", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "longitude", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PharmacyLocationDetails {
    return new PharmacyLocationDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PharmacyLocationDetails {
    return new PharmacyLocationDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PharmacyLocationDetails {
    return new PharmacyLocationDetails().fromJsonString(jsonString, options);
  }

  static equals(a: PharmacyLocationDetails | PlainMessage<PharmacyLocationDetails> | undefined, b: PharmacyLocationDetails | PlainMessage<PharmacyLocationDetails> | undefined): boolean {
    return proto3.util.equals(PharmacyLocationDetails, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PharmacySetupDetails
 */
export class PharmacySetupDetails extends Message<PharmacySetupDetails> {
  /**
   * Date when the pharmacy was set up
   *
   * @generated from field: string setup_date = 1;
   */
  setupDate = "";

  /**
   * Entity that onboarded the pharmacy
   *
   * @generated from field: string onboarding_by = 2;
   */
  onboardingBy = "";

  /**
   * Whether onboarding is allowed for the pharmacy
   *
   * @generated from field: bool allow_onboarding = 3;
   */
  allowOnboarding = false;

  constructor(data?: PartialMessage<PharmacySetupDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PharmacySetupDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "setup_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "onboarding_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "allow_onboarding", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PharmacySetupDetails {
    return new PharmacySetupDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PharmacySetupDetails {
    return new PharmacySetupDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PharmacySetupDetails {
    return new PharmacySetupDetails().fromJsonString(jsonString, options);
  }

  static equals(a: PharmacySetupDetails | PlainMessage<PharmacySetupDetails> | undefined, b: PharmacySetupDetails | PlainMessage<PharmacySetupDetails> | undefined): boolean {
    return proto3.util.equals(PharmacySetupDetails, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PharmacySettings
 */
export class PharmacySettings extends Message<PharmacySettings> {
  /**
   * Type of printer used for invoices (e.g., Thermal)
   *
   * @generated from field: string printer_type = 1;
   */
  printerType = "";

  /**
   * Date format for invoices (e.g., DD/MM/YYYY)
   *
   * @generated from field: string invoice_date_format = 2;
   */
  invoiceDateFormat = "";

  /**
   * Time format for invoices (e.g., hh:mm:ss)
   *
   * @generated from field: string invoice_time_format = 3;
   */
  invoiceTimeFormat = "";

  /**
   * Width of the printer paper in specified unit
   *
   * @generated from field: int32 printer_paper_width = 4;
   */
  printerPaperWidth = 0;

  /**
   * Prefix for invoice numbers
   *
   * @generated from field: string invoice_number_prefix = 5;
   */
  invoiceNumberPrefix = "";

  /**
   * Suffix for invoice numbers
   *
   * @generated from field: string invoice_number_suffix = 6;
   */
  invoiceNumberSuffix = "";

  /**
   * Padding for invoice numbers
   *
   * @generated from field: int32 invoice_number_padding = 7;
   */
  invoiceNumberPadding = 0;

  /**
   * Whether to print barcode on invoices
   *
   * @generated from field: bool print_barcode_on_invoice = 8;
   */
  printBarcodeOnInvoice = false;

  /**
   * Unit of measurement for paper width (e.g., mm)
   *
   * @generated from field: string printer_paper_width_unit = 9;
   */
  printerPaperWidthUnit = "";

  /**
   * Whether to print date on invoices
   *
   * @generated from field: bool print_invoice_date_on_invoice = 10;
   */
  printInvoiceDateOnInvoice = false;

  /**
   * Whether to print time on invoices
   *
   * @generated from field: bool print_invoice_time_on_invoice = 11;
   */
  printInvoiceTimeOnInvoice = false;

  /**
   * Whether to print total on invoices
   *
   * @generated from field: bool print_invoice_total_on_invoice = 12;
   */
  printInvoiceTotalOnInvoice = false;

  /**
   * Whether to print invoice number on invoices
   *
   * @generated from field: bool print_invoice_number_on_invoice = 13;
   */
  printInvoiceNumberOnInvoice = false;

  /**
   * Character used for padding invoice numbers
   *
   * @generated from field: string invoice_number_padding_character = 14;
   */
  invoiceNumberPaddingCharacter = "";

  constructor(data?: PartialMessage<PharmacySettings>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PharmacySettings";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "printer_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "invoice_date_format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "invoice_time_format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "printer_paper_width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "invoice_number_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "invoice_number_suffix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "invoice_number_padding", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "print_barcode_on_invoice", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "printer_paper_width_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "print_invoice_date_on_invoice", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "print_invoice_time_on_invoice", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "print_invoice_total_on_invoice", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "print_invoice_number_on_invoice", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "invoice_number_padding_character", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PharmacySettings {
    return new PharmacySettings().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PharmacySettings {
    return new PharmacySettings().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PharmacySettings {
    return new PharmacySettings().fromJsonString(jsonString, options);
  }

  static equals(a: PharmacySettings | PlainMessage<PharmacySettings> | undefined, b: PharmacySettings | PlainMessage<PharmacySettings> | undefined): boolean {
    return proto3.util.equals(PharmacySettings, a, b);
  }
}

